export const obtenerParkingColor = (nivel) => {
    let color = ''
    switch (nivel) {
      case 1:
        color = 'parking_R';
        break;
      case 2:
        color = 'parking_R'; 
        break;
      case 3:
        color = 'parking_A'; 
        break;
      case 4:
        color = 'parking_N'; 
        break;
      default:
        color = 'parking_N';
        break;
    }
    return color;
  };

export const obtenerNumeroParking = (plazasLibres, nivel, forzadura) => {
  let libres = ''
  let color = ''
  switch (forzadura) {
    case 0:
      switch (nivel) {
        case 1:
          libres = 'LLENO';
          color = '#ff5200'
          break;
        case 2:
          libres = plazasLibres;
          color = '#13ed0f'
          break;
        case 3:
          libres = plazasLibres; 
          color = 'yellow'
          break;
        case 4:
          libres = plazasLibres; 
          color = '#13ed0f'
          break;
        default:
          libres = '---';
          color = 'gray'
          break;
      }
      break;
    case 1:
      libres = 'LLENO';
      color = '#ff5200'
      break;
    case 2:
      libres = 'LIBRE'; 
      color = '#13ed0f'
      break;
    default:
      libres = '---';
      color = 'gray'
      break;
  }
  return {libres, color}
}